import actions from '@/store/modules/storage/turns/actions';
import turns from '@/store/modules/storage/turns/turns';

export default {
    actions,
    turns,
};
